import { render, staticRenderFns } from "./BlogPost.vue?vue&type=template&id=bb085176&lang=pug&"
import script from "./BlogPost.vue?vue&type=script&lang=js&"
export * from "./BlogPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports